<template>
  <UtilLinkItemIcon
    v-editable="blok"
    :blok="{
      component: 'util_link-item-icon',
      type: 'link', // Not relevant as `forceIcon` and `forceIconPosition` are used
      text: props.blok.text,
      link: props.blok.link,
      _uid: props.blok._uid,
    }"
    forceIcon="fi_download"
    forceIconPosition="start"
    :subtext="blok.subtext"
    :isDark="isDark"
    :asset="blok.asset" />
</template>

<script lang="ts" setup>
import UtilLinkItemIcon from '~/components/storyblok/utils/UtilLinkItemIcon/UtilLinkItemIcon.vue';
import type { UtilLinkItemSubtextStoryblok } from '~/types/storyblok-generated';

const props = defineProps<{
  blok: UtilLinkItemSubtextStoryblok;
  isDark?: boolean;
}>();
</script>
